import {
  fetchMentorClassStudentMeeting,
  fetchMentorClassStudentMeetingFilters,
} from "classroom/api/teacher";
import type { FilterResource } from "api/generated";
import {
  saveMentorFeedback as saveMentorFeedback_api,
  shareMyStudentFeedback,
} from "meetings/student-meeting/api/teacher";
import type { MeetingMyStudentsOverview } from "meetings/student-meeting/types";
import { defineStore } from "pinia";

export const useClassroomMentorClassStudentMeetingStore = defineStore(
  "classroomMentorClassStudentMeeting",
  () => {
    const loadStudentMeeting = async (
      mentorClass: string,
      params: Record<string, string> = {},
      signal?: AbortSignal,
    ): Promise<MeetingMyStudentsOverview> => {
      return fetchMentorClassStudentMeeting(mentorClass, params, signal);
    };

    const loadStudentMeetingFilters = async (
      mentorClass: string,
      signal?: AbortSignal,
    ): Promise<FilterResource[]> => {
      return fetchMentorClassStudentMeetingFilters(mentorClass, signal);
    };

    const shareFeedback = async (
      meetingId: number,
      studentId: number,
    ): Promise<void> => {
      await shareMyStudentFeedback(meetingId, studentId);
    };

    const saveMentorFeedback = async (params: {
      meetingId: number;
      studentId: number;
      teacherId: number;
      teacherShortage: string;
      summary: string;
    }): Promise<void> => {
      await saveMentorFeedback_api(params);
    };

    return {
      loadStudentMeeting,
      loadStudentMeetingFilters,
      shareFeedback,
      saveMentorFeedback,
    };
  },
);
